import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getMerchantIntegrationsCurrencies = ({ isLive }: { isLive: boolean }) => {

  const queryParams = {
    is_live: isLive
  };

  return axiosPrivate.get(`/dashboard/api/v1/integrations/currencies`, { params: queryParams });
};